// extracted by mini-css-extract-plugin
export default {"AddBook":"AddBookFrm_AddBook__zrjo-","Form":"AddBookFrm_Form__I9a+O","Title":"AddBookFrm_Title__Py5LT","Author":"AddBookFrm_Author__zpjgJ","Category":"AddBookFrm_Category__3hvHL"};